export function nextDespatchNumber(counterData) {
  const current = counterData?.despatchCounter;
  return typeof current === "number" && Number.isFinite(current)
    ? current + 1
    : 1000;
}

export function auditStamp(user) {
  if (!user || typeof user.uid !== "string" || !user.uid.trim()) {
    return null;
  }

  return {
    uid: user.uid,
    email: user.email ?? null,
  };
}

function authenticationRequiredError(action) {
  const error = new Error(
    `You must be signed in before ${action} a despatch report. Please sign in and try again.`
  );
  error.code = "despatch/auth-required";
  return error;
}

export async function createDespatchRecord({
  firestore,
  countersRef,
  summaryRef,
  detailedRef,
  user,
  runTransactionFn,
  serverTimestampFn,
}) {
  const createdBy = auditStamp(user);
  if (!createdBy) {
    throw authenticationRequiredError("creating");
  }

  return runTransactionFn(firestore, async (tx) => {
    const counterSnap = await tx.get(countersRef);
    const number = nextDespatchNumber(
      counterSnap.exists() ? counterSnap.data() : undefined
    );

    tx.set(
      countersRef,
      { despatchCounter: number },
      { merge: true }
    );
    tx.set(summaryRef, {
      reportNumber: number,
      createdAt: serverTimestampFn(),
      createdBy,
      completed: false,
    });
    tx.set(detailedRef, { items: [] });

    return {
      docId: summaryRef.id,
      number,
    };
  });
}

export async function completeDespatchRecord({
  reportRef,
  user,
  finalItems,
  updateDocFn,
  serverTimestampFn,
}) {
  const completedBy = auditStamp(user);
  if (!completedBy) {
    throw authenticationRequiredError("completing");
  }

  if (!Array.isArray(finalItems)) {
    throw new Error("The final despatch item list is unavailable.");
  }

  await updateDocFn(reportRef, {
    completed: true,
    completedAt: serverTimestampFn(),
    completedBy,
    itemCount: finalItems.length,
  });
}

export async function completeDespatchAndNotify({
  writeCompletion,
  sendCompletionEmail,
}) {
  await writeCompletion();
  return sendCompletionEmail();
}
